import ResponsiveImage from '../../atoms/responsive-image/responsive-image';
import { ContentType } from '../../../types/content';
import MarginSpacing from '../../atoms/margin-spacing/margin-spacing';
import SectionDescription from '../../atoms/section-description/section-description';
import SectionTitle from '../../atoms/section-title/section-title';

export function AboutContent(props: ContentType) {
  const { description, src, title } = props;

  return (
    <div className="flex flex-col m-auto items-start">
      <SectionTitle title={title} />
      <MarginSpacing margin="mt-8" />
      <ResponsiveImage
        alt="content image"
        blurImageSrc="/icons/blur-placeholder.png"
        dimensions="w-full h-96"
        objectFit="cover"
        src={src as string}
      />
      <MarginSpacing margin="mt-5" />
      <SectionDescription
        shouldLinksRedirectToNewTab
        description={description as string}
      />
      <MarginSpacing margin="mb-8" />
    </div>
  );
}

export default AboutContent;
